import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function PrivacyPolicy() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle={`How ${COMPANY.legalName} ("${COMPANY.brand}") collects, uses, and protects your information.`} />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>1. Introduction</h2>
        <p>
          {COMPANY.legalName} (“we”, “our”, “us”) operates the {COMPANY.brand} brand and the website {COMPANY.website}. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. By using our services, you agree to the terms outlined below.
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li><strong>Personal information</strong> you provide voluntarily such as name, email address, phone number, and billing details.</li>
          <li><strong>Device information</strong> such as device model, operating system version, unique identifiers, and app version.</li>
          <li><strong>Usage data</strong> including pages viewed, features used, referring URL, and time spent.</li>
          <li><strong>Cookies and similar technologies</strong> to remember preferences and analyze traffic.</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To provide, maintain, and improve our products and services.</li>
          <li>To process transactions, activations, and support requests.</li>
          <li>To send administrative communications, updates, and security alerts.</li>
          <li>To comply with legal obligations and prevent fraud or abuse.</li>
        </ul>

        <h2>4. On-Device Threat Detection</h2>
        <p>
          {COMPANY.brand} performs threat detection locally on your device wherever possible. We do not upload the contents of your files or personal messages to our servers. Aggregated, non-identifiable telemetry may be used to improve detection quality.
        </p>

        <h2>5. Sharing of Information</h2>
        <p>We do not sell your personal information. We may share limited information with:</p>
        <ul>
          <li>Trusted service providers who assist with payments, hosting, analytics, and customer support under strict confidentiality obligations.</li>
          <li>Law-enforcement or regulators when required by applicable law.</li>
          <li>Successors in the event of a merger, acquisition, or asset sale.</li>
        </ul>

        <h2>6. Data Retention</h2>
        <p>We retain personal information only as long as necessary for the purposes described above or as required by law. You may request deletion of your data at any time by writing to <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>

        <h2>7. Your Rights</h2>
        <p>Subject to applicable law (including GDPR and CCPA), you may have the right to access, correct, delete, or port your personal data, and to object to or restrict certain processing. Contact us to exercise these rights.</p>

        <h2>8. Security</h2>
        <p>We use administrative, technical, and physical safeguards designed to protect your information. However, no method of transmission over the Internet is 100% secure.</p>

        <h2>9. Children&apos;s Privacy</h2>
        <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children.</p>

        <h2>10. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Continued use of our services after changes constitutes acceptance of the revised policy.</p>

        <h2>11. Contact Us</h2>
        <p>
          {COMPANY.legalName}<br />
          {COMPANY.address.line2}, {COMPANY.address.city} {COMPANY.address.zip}, {COMPANY.address.country}<br />
          Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a><br />
          Phone: <a href={`tel:${COMPANY.phoneRaw}`}>{COMPANY.phone}</a>
        </p>
      </LegalBody>
    </>
  );
}
